import { Box, Stack, Text } from '@chakra-ui/react';
import { RawDraftContentState } from 'draft-js';
import * as React from 'react';

import { ImageAlternativeText } from '../ImageAlternativeText';

type ImageEntityData = {
  src?: string;
  alternativeText?: string | null;
  isDecorative?: boolean;
};

export const RichTextImageAltText: React.FC<{
  value: RawDraftContentState | null;
  onChange: (value: RawDraftContentState) => void;
}> = ({ value, onChange }) => {
  const images = Object.entries(value?.entityMap ?? {}).filter(
    ([, entity]) => entity.type === 'IMAGE'
  );

  if (!images.length) {
    return null;
  }

  const updateImage = (
    key: string,
    next: { alternativeText?: string | null; isDecorative?: boolean }
  ) => {
    if (!value) {
      return;
    }

    const entity = value.entityMap[key];
    onChange({
      ...value,
      entityMap: {
        ...value.entityMap,
        [key]: {
          ...entity,
          data: {
            ...entity.data,
            ...next,
          },
        },
      },
    });
  };

  return (
    <Stack spacing="4">
      <Text textStyle="bodyStrong">Image alternative text</Text>
      {images.map(([key, entity], index) => {
        const data = entity.data as ImageEntityData;

        return (
          <Box
            key={key}
            border="1px"
            borderColor="gray.200"
            borderRadius="lg"
            p="4"
          >
            <Text fontSize="sm" color="gray.600" mb="3">
              Image {index + 1}
            </Text>
            <ImageAlternativeText
              alternativeText={data.alternativeText ?? ''}
              onAlternativeTextChange={(nextValue) =>
                updateImage(key, { alternativeText: nextValue || null })
              }
              isDecorative={data.isDecorative !== false}
              onIsDecorativeChange={(isDecorative) =>
                updateImage(key, { isDecorative })
              }
              imageProxy={data.src}
            />
          </Box>
        );
      })}
    </Stack>
  );
};
